import React from 'react';
import { Grid, Cell } from 'react-md';

const SpaceListLoader = () => {
  return (
    <section className="loading-wrap">
      <Grid className="result-grid">
        {[1, 2, 3, 4, 5, 6].map(i => (
          <Cell key={i} size={6} phoneSize={12} tabletSize={6} className="result-cell">
            <section className="card space-list-loader-row">
              <div className="space-img-loading loading" />
              <div className="space-loader-content">
                <div className="space-title-loading loading" />
                <div className="space-subtitle-loading loading" />
                <div className="space-status-loading loading" />
              </div>
            </section>
          </Cell>
        ))}
      </Grid>
    </section>
  );
};

export default SpaceListLoader;